import React from "react";

import { useTranslation } from "lib/i18n/use-translation";

import Info from "../Info";
import { Card, NotEnoughData } from "../engagement/EngagementTab";
import type { EngagementView, FunnelStep } from "../engagement/engagement-view";
import engagementStyles from "../engagement/engagement.module.scss";
import styles from "./engagement-redesign.module.scss";

const K = "admin:companyDashboard.engagement";

// Each step a paler tint of the accent, as the prototype draws them.
const STRENGTHS = [1, 0.6, 0.34];

const Funnel = ({
  funnel,
  day,
}: {
  funnel: EngagementView["funnel"];
  day: string;
}) => {
  const { t } = useTranslation(["admin"]);
  const steps: { key: string; step: FunnelStep; shareOf: string }[] = [
    { key: "activated", step: funnel.activated, shareOf: "ofWorkforce" },
    { key: "everEngaged", step: funnel.everEngaged, shareOf: "ofActivated" },
    {
      key: "repeatEngaged",
      step: funnel.repeatEngaged,
      shareOf: "ofEverEngaged",
    },
  ];
  return (
    <Card
      title={t(`${K}.funnel.title`)}
      description={t(`${K}.funnel.description`)}
    >
      <ol className={styles["funnel"]}>
        {steps.map(({ key, step, shareOf }, index) => (
          <li key={key} className={styles["funnel-step"]}>
            <span className={styles["funnel-head"]}>
              <span className={styles["funnel-name"]}>
                {t(`${K}.funnel.${key}`)}
                <Info
                  figure={t(`${K}.funnel.${key}`)}
                  text={t(`${K}.funnel.${key}Info`)}
                  align="start"
                />
              </span>
              {step.value !== null && (
                <span className={styles["funnel-figure"]}>
                  <span className={styles["funnel-count"]}>{step.value}</span>
                  {step.share && (
                    <span className={styles["funnel-share"]}>
                      {t(`${K}.funnel.${shareOf}`, { share: step.share })}
                    </span>
                  )}
                </span>
              )}
            </span>
            {step.value === null ? (
              <NotEnoughData />
            ) : (
              <span className={styles["funnel-bar"]} aria-hidden="true">
                <span
                  style={{
                    width: `${step.width * 100}%`,
                    opacity: STRENGTHS[index],
                  }}
                />
              </span>
            )}
          </li>
        ))}
      </ol>
      <p className={engagementStyles["footnote"]}>
        {t(`${K}.quarter.footer`, { date: day })}
      </p>
    </Card>
  );
};

export default Funnel;
